import React from 'react'
import { ContentHeader } from '../layout/Content'

function SettingsHeader() {
  return ( <ContentHeader title={'Settings'} /> )
}

export default React.memo(SettingsHeader)
